<template>
  <div class="breadcrumb">
      <img src="@/assets/img/icon4.png" class="img" />
      <router-link to="/" class="home ma-l-10">首页</router-link>
      <span class="ma-lr-10">></span>
      <span>{{ $route.meta.title || "未设置标题" }}</span>
    </div>
</template>

<script>
export default {
    name:'bera'
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  height: 80px;
  display: flex;
  align-items: center;
  .img {
    width: 30px;
    height: 30px;
  }
  .home {
    color: #000;
    &:hover {
      color: #257857;
    }
  }
}


@media only screen and (max-width: 992px) {
  .breadcrumb {
    height: auto;
    font-size: 14px;
    .img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>